// @ts-check
// Cómo piden su lista de ejercicios las tres páginas de editor.
//
// ## Por qué existe
//
// Al cambiar de ejercicio la página se remonta y, para no volver a pedir la
// lista, recibía la que ya tenía... SUSTITUYENDO su cargador por uno que
// devolvía siempre esa misma lista. A partir de ahí ninguna recarga llegaba
// al servidor. Al acertar, el siguiente ejercicio no aparecía hasta refrescar
// la página, y la lista vieja decía "no completado", lo que en el editor de
// diagramas reconstruía el panel y cerraba la ventana del resultado (lo
// encontró el usuario, 2026-09-12).
//
// Aquí la lista ya recibida se usa UNA sola vez, en la primera carga tras el
// remontaje. Las siguientes van siempre al servidor.

/** @typedef {typeof import('../services/progress-client.js').obtenerEjerciciosDeBloque} CargarLista */

/**
 * Envuelve el cargador real de la lista para que la primera llamada use
 * `listaInicial`, si la hay, y todas las demás pregunten al servidor.
 * @param {CargarLista} cargar
 * @param {readonly unknown[] | null} [listaInicial]
 * @returns {CargarLista}
 */
export function crearPedidorDeLista(cargar, listaInicial = null) {
  let pendiente = listaInicial;
  return (bloque, opciones) => {
    if (pendiente) {
      const lista = pendiente;
      pendiente = null;
      return Promise.resolve(/** @type {any} */ (lista));
    }
    return cargar(bloque, opciones);
  };
}
